<template>
	<div class="group-form__field" :class="[customClass, isLink ? 'link' : '']">
		<label class="group-form__field--label" :for="id">{{ title }}</label>
		<input
			class="group-form__field--input"
			:class="alertClass"
			:id="id"
			type="text"
			:maxlength="maxLength"
			:placeholder="placeholder"
			:value="value"
			@input="emitValue($event.target.value)"
			:disabled="isDisabled"
			v-if="!isTextArea && !isFile && !isMasked && !isMoney"
		/>
		<div class="link-icon" v-if="isLink">
			<ChainIcon />
		</div>
		<input
			class="group-form__field--input"
			:id="id"
			type="text"
			:maxlength="maxLength"
			:placeholder="placeholder"
			:value="value"
			@input="emitValue($event.target.value)"
			v-mask="isMasked"
			:disabled="isDisabled"
			v-if="!isTextArea && !isFile && isMasked"
		/>
		<Money
			class="group-form__field--input"
			:id="id"
			type="text"
			:placeholder="placeholder"
			v-model="moneyValue"
			v-bind="money"
			@input="emitValue($event)"
			:disabled="isDisabled"
			v-if="!isTextArea && !isFile && isMoney"
		/>
		<textarea
			class="group-form__field--textarea"
			:class="[alertClass, customClass]"
			:id="id"
			:maxlength="maxLength"
			:placeholder="placeholder"
			:value="value"
			@input="emitValue($event.target.value)"
			type="text"
			v-if="isTextArea"
		/>
		<div :class="customClass" v-if="isFile">
			<label
				class="group-form__field--input file-label"
				:class="[customClass, fileName ? 'active' : '', alertClass]"
				:for="id"
			>
				{{ fileName ? fileName : placeholder }} <PlusIconVariant />
			</label>
			<div class="group-form__field--delete" v-if="isTeaser && fileName" @click="clearTeaser()">
				<span>Excluir Documento</span>
			</div>
			<input
				class="group-form__field--input file"
				type="file"
				:id="id"
				@change="onFileChange"
				accept="application/pdf,text/csv,application/zip"
				v-if="isTeaser"
			/>
			<input
				class="group-form__field--input file"
				type="file"
				:id="id"
				@change="onFileChange"
				v-else
			/>
		</div>
	</div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { Money } from 'v-money';
import PlusIconVariant from '@/components/shared/Icons/PlusIconVariant.vue';
import ChainIcon from '@/components/shared/Icons/ChainIcon.vue';
export default {
	name: 'InputGroup',
	directives: { mask },
	components: { PlusIconVariant, ChainIcon, Money },
	props: {
		title: {
			required: true,
		},
		id: {
			required: true,
		},
		placeholder: {
			required: true,
		},
		alertClass: {
			required: false,
		},
		customClass: {
			required: false,
		},
		value: {
			required: false,
		},
		isTextArea: {
			default: false,
		},
		isFile: {
			default: false,
		},
		isMasked: {
			default: false,
		},
		isMoney: {
			default: false,
		},
		isLink: {
			default: false,
		},
		isTeaser: {
			default: false,
		},
		isDisabled: {
			default: false,
		},
		maxLength: {
			required: false,
		},
	},
	data: () => ({
		fileName: null,
		file: null,
		moneyValue: 0,
		money: {
			decimal: ',',
			thousands: '.',
			prefix: 'R$ ',
			suffix: '',
			precision: 2,
			masked: false,
		},
	}),
	mounted() {},
	methods: {
		emitValue(newValue) {
			this.$emit('input', newValue);
		},
		onFileChange(e) {
			if (e == null) {
				this.fileName = null;
				this.file = null;
			} else {
				const file = e.target.files[0];

				if (this.title == 'Teaser' && !file.name.includes('.pdf')) {
					return this.$toastr.e('O teaser precisa ser um PDF.');
				}

				this.fileName = file.name;
				this.file = file;
				this.$emit('input', this.fileName);
			}
		},
		getFile() {
			return this.file;
		},
		setFileName(param) {
			if (this.isTeaser) {
				this.fileName = param.substring(0, param.indexOf('.pdf')) + '.pdf';
			} else {
				this.fileName = param;
			}
		},
		getFileName() {
			return this.fileName;
		},
		setMoneyValue(param) {
			this.moneyValue = param;
		},
		getMoneyValue() {
			return this.moneyValue;
		},
		clearTeaser() {
			this.fileName = null;
			this.file = null;
			this.$emit('clearTeaser');
		},
	},
	computed: {},
};
</script>

<style lang="scss" scoped>
@import 'InputGroup.scss';
</style>
